/* eslint-disable @typescript-eslint/naming-convention */
import handleError from '@/commons/errorHandler';
import checkout from '@/store/modules/checkout';
import payment from '@/store/modules/payment';
import {bus} from '@/events/bus';
import paidEvent from '@/events/paid';
import redirectToLocation from '@/commons/redirectManager';
import {i18n} from '@/i18n';
import cart from '@/store/modules/cart';
import JQuery from 'jquery';
import { executeIntent, validateBeforePlace } from '@/store/api';
import handleMessage from '@/commons/messageManager';
import { normalizeQuoteAddress } from '@/commons/addressNormalizer';

function onClick(data: any, actions: any) {
    if (cart.isEmpty || checkout.orderPlaced) {
        window.location.reload();
    }

    checkout.setCheckReview(true);
    if (!checkout.agreementsAccepted) {
        handleMessage('error', i18n.t('Accept all agreements to proceed').toString());
        return actions.reject();
    }

    let paymentBillingAddress = normalizeQuoteAddress(checkout.billingAddress);
    return validateBeforePlace(paymentBillingAddress, checkout.email)
        .then(() => {
            return actions.resolve();
        })
        .catch((e) => {
            handleError(e, true);
            return actions.reject();
        });
}

function onInit(data: any, actions: any) {
    if (cart.isEmpty || checkout.orderPlaced) {
        window.location.reload();
    }

    if (!checkout.agreementsAccepted) {
        actions.disable();
    }

    if (document) {
        const privacyCheck = document.querySelector(`input[name='privacy_agreement']`);
        const salesCheck = document.querySelector(`input[name='sales_agreement']`);
        const educationCheck = document.querySelector(`input[name='education_sales_conditions']`);

        if (privacyCheck && salesCheck) {
            privacyCheck.addEventListener('change', () => {
                if (checkout.agreementsAccepted) {
                    actions.enable();
                } else {
                    actions.disable();
                }
            });

            salesCheck.addEventListener('change', () => {
                if (checkout.agreementsAccepted) {
                    actions.enable();
                } else {
                    actions.disable();
                }
            });

            // Optional based on configuration and presence of education onsite products
            if (educationCheck) {
                educationCheck.addEventListener('change', () => {
                    if (checkout.agreementsAccepted) {
                        actions.enable();
                    } else {
                        actions.disable();
                    }
                });
            }
        }
    } else {
        actions.enable();
    }
}

function createOrder(data: any) {
    const extension_attributes =
        checkout.selectedPayment === 'wf_paypalpaylater' || data.paymentSource === null
            ? {}
            : {
                  wfpaypal_save_in_vault: payment.additionalData.paypal_tokenization.save_in_vault,
                  wfpaypal_vault_token: payment.additionalData.paypal_tokenization.vaulted_id,
              };
    const promise = new Promise((resolve) => {
        bus.$emit(paidEvent, {
            payData: {
                extension_attributes,
                checkoutMethod: 'placeAndCreateOrder',
                placeCallback: (orderData: any) => {
                    if (orderData.extension_attributes.paypal_captureid) {
                        // vault is already captured and handled by webhook
                        redirectToLocation('/checkout/onepage/success');
                    } else {
                        resolve(orderData.extension_attributes.paypal_orderid);
                    }
                },
            },
            paymentMethod: checkout.selectedPaymentMethod.code,
        });
    });
    return promise.then((paypalOrderId) => paypalOrderId);
}

function onApprove(data: any) {
    return executeIntent(data.orderID)
        .then(() => {
            redirectToLocation('/checkout/onepage/success');
        })
        .catch((e) => {
            handleError(e);
        });
}

function onError(error: any) {
    // eslint-disable-next-line no-console
    console.log(error);
}

function onCancel() {
    window.location.reload();
}

export default class PayPal {
    private buttons: any;
    private buttonsConfig: any = {
        style: {
            layout: 'horizontal',
            tagline: 'false',
            size: 'responsive',
            color: 'gold',
        },
        onInit,
        onClick,
        createOrder,
        onApprove,
        onError,
        onCancel,
    };

    public init() {
        return new Promise((resolve) => {
            if (this.buttons && this.buttons.close) {
                this.buttons.close();
            }
            checkout.setConfirmStep(true);
            checkout.setCheckReview(true);
            JQuery('#paypal-button').empty();

            if (checkout.selectedPayment === 'wf_paypalpaylater') {
                this.buttonsConfig.fundingSource = 'paylater';
            } else {
                this.buttonsConfig.fundingSource = 'paypal';
            }

            this.buttons = window.paypal.Buttons(this.buttonsConfig);
            this.buttons.render('#paypal-button');

            resolve({buttons: this.buttons});
        });
    }
}
